import React from 'react';
import DataCard, {DataComponentProps} from 'src/components/Cards/DataCard/DataCard';
import JoinPageSignupsDataService, {
  JoinPageSignupsData,
} from 'src/services/JoinPageSignupsDataService';
import {pluralize} from 'shared/utils';
import {useDataService} from 'src/hooks/useDataService';
import {format} from 'date-fns';
import LineGraph, {LineGraphProps} from 'src/components/LineGraph';
import defaultProps from 'src/utils/defaultProps';
import useBrandName from 'src/hooks/use-brand-name';

const shortMonthAndYear = (date: Date): string => format(date, "MMM ''yy");

export const formatLabel: LineGraphProps['labels'] = ({datum}) => {
  const timeframe = shortMonthAndYear(datum.x);
  const count = datum.y.toLocaleString();
  const student = pluralize(datum.y, 'student');
  return `${count} ${student} in ${timeframe}`;
};

const JOIN_PAGE_SIGNUP_ID = 'join-page-signup-chart';

const JoinPageSignupChart = (
  props: DataComponentProps<JoinPageSignupsData>
): React.ReactElement => {
  const serviceState = useDataService({service: props.service});
  const brandName = useBrandName();
  return (
    <DataCard
      blur={serviceState.blur}
      blurText={serviceState.blurText}
      blurCardContent
      loadState={serviceState.loadState}
      title="Join page signups over last 12 months"
      subtitle={`Students who joined ${brandName} via your join page compared to schools of a similar size`}
      elementId={JOIN_PAGE_SIGNUP_ID}
    >
      <LineGraph
        data={[serviceState.data.series.monthSignups, serviceState.data.series.averageMonthSignups]}
        labels={formatLabel}
        legendLabels={['My college', 'Similar schools']}
      />
    </DataCard>
  );
};

export const HsJoinPageSignupChart = defaultProps({
  service: new JoinPageSignupsDataService('/v1/partner_data/join_page_signups'),
})(JoinPageSignupChart);

export const TransferJoinPageSignupChart = defaultProps({
  service: new JoinPageSignupsDataService('/v1/partner_transfer_data/join_page_signups'),
})(JoinPageSignupChart);

export default JoinPageSignupChart;
